module.exports = __webpack_public_path__ + "static/img/partner7.ad19edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner7.png
// module id = HIBF
// module chunks = 0